import React from 'react'
import { ItemsRequestModel } from '.'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import SectionBoxContainer from '../../components/SectionBoxContainer';
import DateAndTime from '../DateAndTime';


interface IRequestTimelineProps{
    request: ItemsRequestModel,
}

export default function RequestTimeline(props: IRequestTimelineProps) {

    const { request } = props

    interface Step {
        title: string,
        message: string,
        date: string,
        completed?: boolean,
    }

    let isApproved: boolean = false
    let isPrepared: boolean = false
    let isReached: boolean = false
    let isBackToOrigin: boolean = false
    let isOnTheWay: boolean = false
    let isOnTheWayBack: boolean = false


    let preparing: string = ""
    let inTransit: string = ""
    let reached: string = ""
    let goingBack: string = ""
    let origin: string = ""
    let completed: string = ""


    switch(request.status){

        case "pending":
            break

        case "approved":
            isApproved = true
            break

        case "preparing":
            isApproved = true
            break

        case "ready":
            isApproved = true
            isPrepared = true
            break

        case "transit":
            isApproved = true
            isPrepared = true
            isOnTheWay = true
            break

        case "fulfilled":
            isApproved = true
            isPrepared = true
            isReached = true
            isOnTheWay = true
            break

        case "returning":
            isApproved = true
            isPrepared = true
            isReached = true
            isOnTheWay = true
            isOnTheWayBack = true
            break

        case "returned":
            isApproved = true
            isPrepared = true
            isReached = true
            isBackToOrigin = true
            isOnTheWay = true
            isOnTheWayBack = true
            isBackToOrigin = true
            break

        case "closed":
            isApproved = true
            isPrepared = true
            isReached = true
            isBackToOrigin = true
            isOnTheWay = true
            isOnTheWayBack = true
            isBackToOrigin = true
            break

    }

    if (isPrepared){
        preparing = "The items have been preapred and are ready to be temporarily moved to the request destination."
    }else{
        preparing = "Items are being prepared."
    }

    if (isOnTheWay){
        inTransit = "Items have been sent from the warehouse and now are on the way to the destination."
    }

    if (isReached){
        reached = `Items have been received by ${request.destination_user_name ? request.destination_user_name : request.request_by_name}.`
    }

    if (isOnTheWayBack){
        goingBack = `${request.destination_user_name ? request.destination_user_name : request.request_by_name} sent the items back. Items are on the way back to the warehouse.`
    }

    if (isBackToOrigin){
        origin = `Items reached back to the warehouse.`
    }

    let steps: Step[] = [
        {
            title: "Request Created",
            message: "Waiting for the approval",
            date: request.created_at,
            completed: true,
        },
        {
            title: isApproved ? "Approved" : "Pending",
            message: isApproved ? "Request has been approved." : "Waiting for approval.",
            date: request.reviewed_at ? request.reviewed_at : "",
            completed: isApproved
        },
        {
            title: isPrepared ? "Items Prepared" : "Preparing Items",
            message: preparing,
            date: "",
            completed: isPrepared,
        },
        {
            title: "On the way",
            message: inTransit,
            date: request.transit_at ? request.transit_at : "",
            completed: isOnTheWay
        },
        {
            title: "Reached Destination",
            message: reached,
            date: request.received_at ? request.received_at : "",
            completed: isReached,
        },
        {
            title: "On the way back",
            message: goingBack,
            completed: isOnTheWayBack,
            date: request.returning_at ? request.returning_at : "",
        },
        {
            title: "Received back to origin",
            message: origin,
            date: request.returned_at ? request.returned_at : "",
            completed: isBackToOrigin,
        },
        {
            title: "Completed",
            message: request.status === "closed" ? "Request has been completed and closed" : "",
            date: request.closed_at ? request.closed_at : "",
            completed: request.status === "closed" ? true : false
        },
    ]

    const dateAndTime = new DateAndTime()

    return(
        <div className="items-request-timeline">
            <SectionBoxContainer
                showTitle
                title="Timeline"
                noWrap
            >
                <Timeline
                    sx={{
                        [`& .${timelineOppositeContentClasses.root}`]: {
                        flex: 0.22,
                        },
                    }}
                >

                    {steps.map((step, index) => {

                        return(
                            <TimelineItem className={step.completed ? "completed" : ""} key={index}>
                                <TimelineOppositeContent color="textSecondary">
                                    {step.date ? dateAndTime.formatDateAndTime(step.date) : ""}
                                </TimelineOppositeContent>

                                <TimelineSeparator>

                                    <TimelineDot color={step.completed ? "success" : "grey"} />

                                <TimelineConnector />

                                </TimelineSeparator>

                                <TimelineContent>
                                    <h3 className="timeline-title">{step.title}</h3>
                                    {step.message && <p className="timeline-message">{step.message}</p>}
                                </TimelineContent>
                            </TimelineItem>
                        )
                    })}

                </Timeline>

            </SectionBoxContainer>
        </div>
    )
}